// extracted by mini-css-extract-plugin
export default {"title":"EventDetails_title__rneMs","knowmore":"EventDetails_knowmore__pAfj+","description":"EventDetails_description__9AU3T","details":"EventDetails_details__tuRC0"};